import {useEffect, useState} from "react";
import React from "react";
import axios from "axios";
import {useNavigate, useLocation, useParams} from "react-router-dom";
import './PeymentComplete.css'
import { toast } from "react-toastify";


export default function PeymentComplete(props){

    // eslint-disable-next-line react-hooks/rules-of-hooks
      const [seconds, setSeconds] = useState(5)
      const navigate = useNavigate();
      const [amount,setamount] = useState()
      const [cardNumber,setcartNumbrr] = useState()
      const[status,setStatus] = useState()


      let query = useQuery()
      let token = query.get("trx")
      let payment_status = query.get("payment_status")
      





    function useQuery() {
            const { search } = useLocation();

            return React.useMemo(() => new URLSearchParams(search), [search]);
            }




            useEffect(()=>{

                async function fetchData() {
                    if (token){
                    // You can await here
                    const response = await axios.post("https://api.sinatether.com/Auth/PaymentVerify/",{"token":token},{withCredentials:true}).then((res)=>{
                        if (res.status == 200){

                                if(res.data['status'] == 1){
                                    setamount(res.data['amount'])
                                    setcartNumbrr(res.data["cardNumber"])
                                    setStatus('OK')

                                }else{
                                    setStatus('Fail')
                                }


                            

                        }
                    }).catch((error)=>{

                    });
                    }

                    // ...
                  }
                  fetchData();
                


                
            },[])




      // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(()=>{
        if (seconds>0){
            setTimeout(()=> setSeconds(seconds-1),1000)
        }else{
            navigate('/')
        }
    })


    function action(){


                  axios.post('https://api.sinatether.com/Auth/PaymentVerify/',{'token':token},{withCredentials:true}).then((res)=>{
                      navigate('/')
                    }).catch((error)=>{
                        if(error){
                            if (error.response.status === 400){
                                toast.dismiss()
                                toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                            }
                            navigate('/')

                        }

                  })







    }



    return(
        <>
            <div className={'row align-items-center mt-5 bg-white'}>

            <div className={'pdiv pt-2 pb-2'}>
                <div className={'align-items-center text-center'}>
                    <div>{seconds}</div>
                    { status && status == 'OK'&&
                         <div>
<div>
                                 <svg xmlns="http://www.w3.org/2000/svg" width="40.667" height="80.666" viewBox="0 0 938.667 938.666">
  <path id="success-24" d="M512,981.333C252.8,981.333,42.667,771.2,42.667,512S252.8,42.667,512,42.667,981.333,252.8,981.333,512,771.2,981.333,512,981.333Zm-50.432-326.1L310.613,504.32a32,32,0,0,0-45.227,45.227L440.106,724.31q.169.172.341.341l.256.213a32,32,0,0,0,50.048-6.144L828.2,339.115a32.006,32.006,0,1,0-47.872-42.5L461.568,655.232Z" transform="translate(-42.667 -42.667)" fill="#52c41a"/>
            </svg>
                                    {amount && cardNumber ?
                                                            <p>پرداخت با موفقیت انجام شد </p>
                                                            :
                                                            <p>درحال بررسی...</p>
                                    }
                                 <div className={'row'}>
                                 <div className={'col-6 text-large text-left'}>
                                     مبلغ تراکنش:
                                 </div>
                                 <div className={'col-6 text-large text-right pl-0'}>
                                     {amount ?
                                     <span>
                                     {new Intl.NumberFormat("fa").format(amount)}تومان
                                     </span>
                                     :
                                     <span>
                                         درحال بررسی...
                                     </span>
                                     }
                                     
                                 </div>
                             </div>
                              <div className={'row'}>
                                 <div className={'col-6 text-large text-left'}>
                                      کارت بانکی :
                                 </div>
                                 <div className={'col-6 text-large text-right pl-0'}>
                                     {cardNumber ? 
                                     <span>
                                     {cardNumber}
                                     </span>
                                     :
                                     <span>
                                         درحال بررسی...
                                     </span>
                                    }
                                 </div>
                             </div>



                             </div>
                             <div className={'row'}>
                                 <span className={' text-large text-danger'}>
                                     توجه : درصورت عدم احراز کارت بانکی مبلغ واریزی بلوکه خواهد شد.

                                 </span>

                             </div>
                        <button className={'btn btn-success mt-2'} >ادامه و تکمیل فرایند</button>
                             </div>

                                }

                    {status && status == 'Fail' &&
                        
                     <div>
                                                  <div>
                             <svg xmlns="http://www.w3.org/2000/svg" width="40.072" height="80.072" viewBox="0 0 252.072 252.072">
                                <g id="warning-sign-9772" transform="translate(126.036 126.036)">
                                    <g id="Group_364" data-name="Group 364" transform="translate(-126.036 -126.036)">
                                    <path id="Path_562" data-name="Path 562" d="M126.036,252.072A126.036,126.036,0,1,1,252.072,126.036,126.179,126.179,0,0,1,126.036,252.072Z" fill="#e50000"/>
                                    <path id="Path_563" data-name="Path 563" d="M126.036,160.959h0a9.529,9.529,0,0,1-9.52-9.108l-8.783-84.772a18.355,18.355,0,0,1,18.3-19.729h0a18.355,18.355,0,0,1,18.3,19.729l-8.786,84.772A9.523,9.523,0,0,1,126.036,160.959Z" fill="#fff"/>
                                    <circle id="Ellipse_23" data-name="Ellipse 23" cx="15.18" cy="15.18" r="15.18" transform="translate(110.856 174.35)" fill="#fff"/>
                                    </g>
                                </g>
                                </svg>


                         </div>

                        <p>پرداخت با موفقیت انجام نشد </p>
                        <button className={'btn btn-danger mt-1'} onClick={action}>ادامه و تکمیل فرایند</button>
                    </div>

                    }


                    {!status &&


                        <div className="pt-4 pb-4">
                            در حال دریافت اطلاعات ...

                        </div>

                    }
                    


                </div>
                <hr/>

            </div>
            </div>


        </>
    )
}